import { BehaviorSubject } from 'rxjs';

import { DocumentSearchQuery } from 'shared/models/api/models';

export interface SearchStateParams {
    from?: string;
    replace?: boolean;
    state?: any;
    preventScrollReset?: boolean;
    flushSync?: boolean;
    viewTransition?: boolean;
}

export type DocumentSearchState = {
    query: DocumentSearchQuery,
    runQuery?: boolean,
    pushHistory?: boolean
}

const emptyQuery: DocumentSearchQuery = {
    searchTerm: '',
    statusIds: [],
    typeIds: [],
    moduleIds: [],
    dateRange: undefined,
    fullMatchContentRequired: false
}
const createInitialState = (): DocumentSearchState => ({ query: Object.assign({}, emptyQuery) })

const documentSearchStateSubject = new BehaviorSubject<DocumentSearchState>(createInitialState());

export const documentSearchState = {
    subscribe: (setState: any) => documentSearchStateSubject.subscribe(setState),
    setState: (fn: (state: DocumentSearchState) => void) => {
        var newState = Object.assign({}, documentSearchStateSubject.getValue());
        fn(newState);
        documentSearchStateSubject.next(newState);
    },
    reset: () => {
        documentSearchStateSubject.next(createInitialState());
    }
}
